import { VehicleSnapshot } from '../../../shared/vehicle/models/vehicle-snapshot.models';
import { IVehicle, Vehicle } from '../../../shared/vehicle/models/vehicle.class';
import { VehicleAlerts, VehicleStates } from './live.static';

type IVehicleStateful = IVehicle & {
  states?: Set<VehicleStates>;
  alerts?: Set<VehicleAlerts>;
  filteredOut?: boolean;
  lastSnapshot?: VehicleSnapshot;
};

/**
 * Vehicle Interface for LIVE and Maps
 */
export class VehicleStateful extends Vehicle {
  states: Set<VehicleStates> = new Set();
  alerts: Set<VehicleAlerts> = new Set();
  filteredOut: boolean = false;
  lastSnapshot?: VehicleSnapshot;

  constructor(id: string | number, v_id: string, vin: string, options?: IVehicleStateful) {
    super(id, v_id, vin, options);

    if (options) {
      if (options.states) this.states = options.states;
      if (options.alerts) this.alerts = options.alerts;
      if (options.filteredOut !== undefined) this.filteredOut = options.filteredOut;
    }
  }

  static override filterPredicate(
    vehicle: VehicleStateful,
    _filter: VehicleStates | string | undefined
  ): boolean {
    // return the original array if _filter value is invalid
    if (!_filter) return true;

    // pass filtering down to the default Vehicle filter and return the result
    return vehicle.states.has(_filter as VehicleStates) || super.filterPredicate(vehicle, _filter);
  }

  static convert(vehicle: Vehicle): VehicleStateful {
    return new VehicleStateful(vehicle.id, String(vehicle.v_id), vehicle.vin, { ...vehicle });
  }
}

/**
 * Main Vehicle Dictionary
 */
export type VehicleDictionary = { [vehicleId: string]: VehicleStateful };

/**
 * Live traffic data from HERE
 */
export type LiveTrafficData = {
  type: 'FeatureCollection';
  features: {
    type: 'Feature';
    geometry: {
      type: 'LineString';
      coordinates: [lng: number, lat: number][];
    };
    properties: {
      current: number;
      current_uncapped: number;
      freeflow: number;
    };
  }[];
};

/**
 * Weather data from OpenWeatherMap
 */
export type Weather = {
  updated_at: string;
  weather_icon: string;
  weather: string;
  temp: number;
  unit: string;
  wind_direction_degrees: number;
  wind_direction_label: string;
  wind_mph: number;
};
